// BatteryLifeCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Waktu Pengoperasian Baterai - Hitung Jumlah Jam Kerja Baterai";
const DESCRIPTION =
  "Hitung waktu pengoperasian baterai perangkat tertentu berdasarkan kapasitas baterai dan arus yang ditarik perangkat. Kalkulator ini membantu Anda mengetahui berapa lama waktu pengoperasian yang dapat Anda peroleh dari baterai tertentu.";
const KEYWORDS = "kalkulator, baterai, waktu pengoperasian, kapasitas, arus, perangkat";
const OG_URL =
  "https://do-calculate.com/calculator/id/battery-life-calculator/";
function BatteryLifeCalculator() {
  const [batteryCapacity, setBatteryCapacity] = useState("0");
  const [deviceCurrentDraw, setDeviceCurrentDraw] = useState("0");
  const [operatingTime, setOperatingTime] = useState(null);
  const [error, setError] = useState("");
  const calculateOperatingTime = () => {
    try {
      if (batteryCapacity === "0" && deviceCurrentDraw === "0") {
        setError("Silakan masukkan nilai untuk menghitung waktu pengoperasian");
        return;
      }
      const time = batteryCapacity / deviceCurrentDraw;
      setOperatingTime(time);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
                    <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menyediakan cara sederhana untuk menghitung waktu pengoperasian baterai saat terhubung ke perangkat tertentu. Waktu pengoperasian tergantung pada kapasitas baterai (diukur dalam ampere-jam) dan arus yang ditarik perangkat (diukur dalam ampere). Dengan memasukkan nilai-nilai ini, Anda dapat dengan mudah mengetahui berapa jam baterai akan beroperasi sebelum perlu diisi ulang. Ini sangat berguna saat merencanakan penggunaan perangkat portabel atau persiapan daya cadangan.
                </p>
                <p>
                  Misalnya, jika Anda memiliki baterai dengan kapasitas 150 ampere-jam dan menggunakannya untuk menjalankan perangkat yang menarik arus 30 ampere, Anda dapat menggunakan kalkulator ini untuk menghitung waktu pengoperasian yang diharapkan dari baterai. Informasi ini penting dalam berbagai situasi, seperti saat berkemah atau dalam keadaan darurat di mana daya yang tersedia terbatas dan Anda perlu mengelola penggunaannya dengan bijak.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="battery-capacity">
                      Kapasitas Baterai (Ampere-jam):
                    </label>
                    <input
                      id="battery-capacity"
                      type="number"
                      value={batteryCapacity}
                      onChange={(e) => setBatteryCapacity(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                    <span className="input-group-text">Ah</span>
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="device-draw">
                      Arus yang Ditarik Perangkat (Ampere):
                    </label>
                    <input
                      id="device-draw"
                      type="number"
                      value={deviceCurrentDraw}
                      onChange={(e) => setDeviceCurrentDraw(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                    <span className="input-group-text">A</span>
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateOperatingTime}
                  >
                    Hitung
                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">Error: {error}</p>
                ) : (
                  operatingTime !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>
                        Waktu pengoperasian yang diharapkan: {operatingTime.toFixed(2)} jam
                      </p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Cara Menghitung Waktu Pengoperasian Baterai</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 1: Tentukan Kapasitas Baterai
                    </h2>
                  </u>
                  <p>
                    Pertama, Anda perlu mengetahui kapasitas baterai yang Anda gunakan,
                    diukur dalam satuan ampere-jam (Ah). Kapasitas baterai mewakili jumlah
                    muatan listrik yang dapat disimpan baterai. Penting untuk mengetahui
                    kapasitas baterai yang tepat karena ini akan secara langsung mempengaruhi
                    durasi pengoperasian perangkat yang terhubung dengannya. Kapasitas baterai
                    biasanya dapat ditemukan tertulis pada label baterai itu sendiri.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 2: Ketahui Arus yang Ditarik Perangkat
                    </h2>
                  </u>
                  <p>
                    Setelah menentukan kapasitas baterai, langkah berikutnya adalah mengetahui arus yang ditarik
                    oleh perangkat yang akan dijalankan oleh baterai. Arus yang ditarik diukur dalam ampere (A)
                    dan mewakili jumlah arus listrik yang dibutuhkan perangkat untuk beroperasi. Informasi ini
                    dapat ditemukan di manual pengguna perangkat atau pada label yang ada pada perangkat itu sendiri.
                    Informasi ini penting karena arus yang ditarik secara langsung mempengaruhi seberapa cepat
                    baterai terkuras.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 3: Hitung Waktu Pengoperasian
                    </h2>
                  </u>
                  <p>
                    Sekarang setelah Anda mengetahui kapasitas baterai dan arus yang ditarik, Anda dapat menghitung
                    waktu pengoperasian yang diharapkan. Untuk menghitung waktu pengoperasian, bagi kapasitas baterai
                    (dalam ampere-jam) dengan arus yang ditarik perangkat (dalam ampere).
                    Ini akan memberi Anda jumlah jam baterai akan beroperasi sebelum perlu diisi ulang.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: 150 Ah / 30 A = 5 jam.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 4: Verifikasi Perhitungan dan Ekspektasi Kinerja
                    </h2>
                  </u>
                  <p>
                    Setelah melakukan perhitungan, penting untuk memastikan bahwa nilai yang Anda gunakan
                    benar dan perhitungan akurat. Mungkin ada faktor tambahan yang mempengaruhi kinerja
                    baterai seperti suhu atau efisiensi perangkat. Oleh karena itu, hasilnya mungkin
                    merupakan perkiraan dan tidak sepenuhnya akurat. Pastikan untuk memantau kinerja
                    baterai dalam penggunaan sebenarnya untuk memastikan perhitungan sesuai dengan kenyataan.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Ingat: Kinerja sebenarnya dapat bervariasi berdasarkan berbagai faktor seperti efisiensi perangkat dan suhu.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BatteryLifeCalculator;